/* eslint-disable */
import styles from './style.module.scss';
import { Title } from '../../typography/Title/Title';
import { t } from '@web-solutions/module-localization';
import Button from '../button/Button';
import Analytics from '@web-solutions/module-analytics';
import { useNav } from 'src/onboarding/hooks/nav';
import { renderHighlightedTitle } from 'src/onboarding/helpers/renderHighlightedTitle';
import { useRemoteConfig } from '@web-solutions/base-app/hooks/use-remote-config';
import getLocale from 'src/localization/get-locale';

export const GiftPopup = ({ isOpen, onClose }) => {
  const { currentIndex } = useNav();
  const { giftPopup } = useRemoteConfig();
  const locale = getLocale();

  if (!isOpen) {
    return null;
  }

  const handleContinue = () => {
    Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
      popup: 'gift-popup',
    });
    onClose();
  };

  return (
    <>
      <div className={styles.overlay} onClick={onClose} />

      <div className={styles.popup}>
        <div className={styles.image}></div>

        <Title tag='h4' className={styles.title}>
          {renderHighlightedTitle(giftPopup.title[locale])}
        </Title>

        <Button title={giftPopup.buttonTitle[locale]} onClick={handleContinue} />
      </div>
    </>
  );
};
